export default __webpack_public_path__ + "3dba4feb7c35456907994869f7ca07bd.jpg";